{
  "actions.add": "Add",
  "actions.apply": "Apply",
  "actions.archive": "Archive",
  "actions.assign": "Assign",
  "actions.back": "Back",
  "actions.cancel": "Cancel",
  "actions.clear": "Clear",
  "actions.clearAll": "Clear all",
  "actions.close": "Close",
  "actions.collapse": "Collapse",
  "actions.confirm": "Confirm",
  "actions.continue": "Continue",
  "actions.copy": "Copy",
  "actions.copyLink": "Copy link",
  "actions.create": "Create",
  "actions.delete": "Delete",
  "actions.deselectAll": "Deselect all",
  "actions.disable": "Disable",
  "actions.discard": "Discard",
  "actions.discardChanges": "Discard changes",
  "actions.disconnect": "Disconnect",
  "actions.done": "Done",
  "actions.download": "Download",
  "actions.duplicate": "Duplicate",
  "actions.edit": "Edit",
  "actions.enable": "Enable",
  "actions.expand": "Expand",
  "actions.export": "Export",
  "actions.filter": "Filter",
  "actions.generate": "Generate",
  "actions.keepEditing": "Keep editing",
  "actions.move": "Move",
  "actions.next": "Next",
  "actions.open": "Open",
  "actions.preview": "Preview",
  "actions.previous": "Previous",
  "actions.refresh": "Refresh",
  "actions.remove": "Remove",
  "actions.rename": "Rename",
  "actions.reset": "Reset",
  "actions.restore": "Restore",
  "actions.retry": "Retry",
  "actions.save": "Save",
  "actions.saveChanges": "Save changes",
  "actions.search": "Search",
  "actions.select": "Select",
  "actions.selectAll": "Select all",
  "actions.send": "Send",
  "actions.showLess": "Show less",
  "actions.showMore": "Show more",
  "actions.submit": "Submit",
  "actions.test": "Test",
  "actions.tryAgain": "Try again",
  "actions.undo": "Undo",
  "actions.update": "Update",
  "actions.upload": "Upload",
  "actions.view": "View",
  "actions.viewDetails": "View details",
  "answer.no": "No",
  "answer.yes": "Yes",
  "aria.clearSearch": "Clear search",
  "aria.dismiss": "Dismiss",
  "aria.moreActions": "More actions",
  "brands.createFailed": "Failed to create brand",
  "brands.deleteFailed": "Failed to delete brand",
  "brands.loadFailed": "Failed to fetch organization brands",
  "brands.setDefaultFailed": "Failed to set default brand",
  "brands.updateFailed": "Failed to update brand",
  "confirm.archiveTitle": "Archive {{name}}?",
  "confirm.title": "Are you sure?",
  "count.candidates_one": "{{count}} candidate",
  "count.candidates_other": "{{count}} candidates",
  "count.jobs_one": "{{count}} job",
  "count.jobs_other": "{{count}} jobs",
  "count.selected_one": "{{count}} selected",
  "count.selected_other": "{{count}} selected",
  "dates.dateAtTime": "{{date}} at {{time}}",
  "dates.dateRange": "Date range",
  "dates.durationHoursMinutes": "{{hours}}hr {{minutes}}m",
  "dates.durationMinutes": "{{minutes}}m",
  "dates.durationMinutesSeconds": "{{minutes}}m {{seconds}}s",
  "dates.durationSeconds": "{{seconds}}s",
  "dates.justNow": "Just now",
  "dates.today": "Today",
  "dates.todayAt": "Today at {{time}}",
  "dates.weekday.friday": "Friday",
  "dates.weekday.monday": "Monday",
  "dates.weekday.saturday": "Saturday",
  "dates.weekday.sunday": "Sunday",
  "dates.weekday.thursday": "Thursday",
  "dates.weekday.tuesday": "Tuesday",
  "dates.weekday.wednesday": "Wednesday",
  "dates.yesterday": "Yesterday",
  "empty.noData": "No data",
  "empty.noDataYet": "No data yet",
  "empty.noMatches": "No matches for \"{{query}}\"",
  "empty.noResults": "No results found",
  "errors.pageTitle": "Something went wrong",
  "errors.reloadPage": "Reload page",
  "feedback.clipboardCopyFailed": "Failed to copy to clipboard",
  "feedback.copyFailed": "Failed to copy",
  "feedback.copyFailedTitle": "Copy failed",
  "feedback.errorOccurred": "An error occurred",
  "feedback.genericError": "Something went wrong. Please try again.",
  "feedback.loadFailed": "Failed to load data",
  "feedback.networkError": "Network error. Check your connection and try again.",
  "feedback.saveFailed": "Failed to save changes",
  "feedback.saveSuccess": "Changes saved",
  "fields.actions": "Actions",
  "fields.candidate": "Candidate",
  "fields.created": "Created",
  "fields.createdBy": "Created by",
  "fields.date": "Date",
  "fields.description": "Description",
  "fields.email": "Email",
  "fields.endDate": "End date",
  "fields.firstName": "First name",
  "fields.job": "Job",
  "fields.label": "Label",
  "fields.language": "Language",
  "fields.lastName": "Last name",
  "fields.lastUpdated": "Last updated",
  "fields.location": "Location",
  "fields.message": "Message",
  "fields.name": "Name",
  "fields.organization": "Organization",
  "fields.phone": "Phone",
  "fields.phoneNumber": "Phone number",
  "fields.recruiter": "Recruiter",
  "fields.role": "Role",
  "fields.settings": "Settings",
  "fields.source": "Source",
  "fields.startDate": "Start date",
  "fields.status": "Status",
  "fields.tags": "Tags",
  "fields.template": "Template",
  "fields.timezone": "Time zone",
  "fields.title": "Title",
  "fields.type": "Type",
  "fields.url": "URL",
  "fields.user": "User",
  "fields.value": "Value",
  "filters.any": "Any",
  "filters.title": "Filters",
  "languageMode.candidateChoice": "Candidate Choice",
  "languageMode.multiLingual": "Multi-Lingual",
  "languagePicker.description": "Choose the language of the Tenzo app. Interviews and messages to candidates keep the language set on each job.",
  "languagePicker.label": "Language",
  "languagePicker.orgDefaultOption": "Organization default ({{language}})",
  "languagePicker.partialNotice": "Some pages may still appear in English while translations are completed.",
  "languagePicker.reloadNotice": "Saving reloads the page to apply the new language.",
  "languagePicker.saveFailed": "Failed to update the display language",
  "languagePicker.tab": "Preferences",
  "languagePicker.title": "Display language",
  "notify.warningTitle": "Warning: {{title}}",
  "organization.loadFailed": "Failed to fetch organization",
  "organization.notLoaded": "Organization is not loaded",
  "organization.updateFailed": "Failed to update organization",
  "pagination.loadMore": "Load more",
  "pagination.nextPage": "Next page",
  "pagination.previousPage": "Previous page",
  "pagination.showing": "Showing {{from}}-{{to}} of {{total}}",
  "search.placeholder": "Search...",
  "status.active": "Active",
  "status.all": "All",
  "status.archived": "Archived",
  "status.beta": "Beta",
  "status.connected": "Connected",
  "status.copied": "Copied",
  "status.copiedToClipboard": "Copied to clipboard",
  "status.custom": "Custom",
  "status.default": "Default",
  "status.deleted": "Deleted",
  "status.disabled": "Disabled",
  "status.draft": "Draft",
  "status.enabled": "Enabled",
  "status.error": "Error",
  "status.failed": "Failed",
  "status.inactive": "Inactive",
  "status.loading": "Loading...",
  "status.new": "New",
  "status.none": "None",
  "status.notAvailable": "N/A",
  "status.off": "Off",
  "status.on": "On",
  "status.optional": "Optional",
  "status.processing": "Processing...",
  "status.required": "Required",
  "status.saved": "Saved",
  "status.saving": "Saving...",
  "status.sending": "Sending...",
  "status.success": "Success",
  "status.unknown": "Unknown",
  "status.updating": "Updating...",
  "status.warning": "Warning",
  "table.columns": "Columns",
  "table.sortAscending": "Sort ascending",
  "table.sortDescending": "Sort descending",
  "timezoneGroups.africa": "Africa",
  "timezoneGroups.asia": "Asia",
  "timezoneGroups.australiaPacific": "Australia & Pacific",
  "timezoneGroups.detected": "Detected",
  "timezoneGroups.europe": "Europe",
  "timezoneGroups.global": "Global",
  "timezoneGroups.latinAmerica": "Latin America",
  "timezoneGroups.middleEast": "Middle East",
  "timezoneGroups.usCanada": "US & Canada",
  "unsaved.title": "Unsaved changes",
  "validation.invalidEmail": "Enter a valid email address",
  "validation.invalidPhone": "Enter a valid phone number",
  "validation.request.fieldChoice": "Value not allowed: {{field}}",
  "validation.request.fieldFormat": "Invalid format: {{field}}",
  "validation.request.fieldInvalid": "Invalid value: {{field}}",
  "validation.request.fieldRange": "Value out of range: {{field}}",
  "validation.request.fieldRequired": "Missing required field: {{field}}",
  "validation.request.fieldTooLong": "Value too long: {{field}}",
  "validation.request.fieldTooShort": "Value too short: {{field}}",
  "validation.request.invalid": "The request contains invalid data. Check your entries and try again.",
  "languageRecovery.title": "Your selected language couldn't be loaded",
  "languageRecovery.timeout": "Your language is taking longer than expected to load. You can continue in English and retry. Your language preference is unchanged.",
  "languageRecovery.unavailable": "Your language couldn't be loaded. Check your connection and retry. You can continue in English. Your language preference is unchanged."
}
